import { useTreeModifyContext } from "../TreeDataContext";
import { useConditionalContext } from "./ConditionalContext";
import React, { useCallback } from "react";
import { Box, IconButton, TextField, Typography } from "@mui/material";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { IndexableObject } from "../Helpers";
import { usePathContext } from "../PathInfo";

interface ConditionalCheckProps {
  keyValue: string;
  value: string;
  path: string[];
  index: number;
  allConditions: object;
}

export function ConditionalCheck(props: ConditionalCheckProps) {
  const { saveChangesAtPath, removeAtPath } = useTreeModifyContext();
  const { path } = usePathContext();
  const { selectedCondition, conditions, unconditionedName } = useConditionalContext();
  const [currentKey, setCurrentKey] = React.useState<string>(props.keyValue);
  const [currentSaveKey, setCurrentSaveKey] = React.useState<string>(props.keyValue);
  const [currentValue, setCurrentValue] = React.useState<string | string[]>(props.value);

  const performSave = useCallback(
    (newKey: string, newValue: string | string[]) => {
      if (newKey === "" || newValue === "") {
        return;
      }

      let newConditions: IndexableObject = Object.assign({}, props.allConditions);
      delete newConditions[currentSaveKey];

      if (!Array.isArray(newValue) && newValue.toString().includes(",")) {
        newConditions[newKey] = newValue
          .toString()
          .split(",")
          .map((value) => value.trim());
      } else {
        newConditions[newKey] = newValue.toString();
      }

      saveChangesAtPath(newConditions, props.path);
      setCurrentSaveKey(newKey);
    },
    [currentSaveKey, props.allConditions, props.path, saveChangesAtPath],
  );

  return (
    <Box className="horizontal-flex">
      <TextField
        size="small"
        fullWidth={true}
        value={currentKey}
        onBlur={(event) => {
          performSave(currentKey, currentValue);
        }}
        onChange={(event) => {
          setCurrentKey(event.target.value.toString());
        }}
      />
      <Typography key={props.index} component={"span"}>
        :
      </Typography>
      <TextField
        size="small"
        fullWidth={true}
        value={currentValue}
        onBlur={(event) => {
          performSave(currentKey, currentValue);
        }}
        onChange={(event) => {
          setCurrentValue(event.target.value.toString());
        }}
      />
      <IconButton
        color={"warning"}
        onClick={() => {
          let newConditions: IndexableObject = Object.assign({}, props.allConditions);
          delete newConditions[currentSaveKey];
          if (Object.keys(newConditions).length === 0 && selectedCondition === 0) {
            if (conditions!.length === 1) {
              removeAtPath(props.path.slice(0, -2));
              saveChangesAtPath(conditions![0].result, path.concat(unconditionedName));
              return;
            }
            if (selectedCondition === 0) {
              removeAtPath(props.path.slice(0, -1));
              saveChangesAtPath(conditions![0].result, path.concat(unconditionedName));
              return;
            }
          }
          saveChangesAtPath(newConditions, props.path);
        }}
      >
        <RemoveCircleOutlineIcon />
      </IconButton>
    </Box>
  );
}
